<template>
  <div class="context-wrapper">
    <div class="context">
      <div class="context-item">
        <div class="context-item__value price">
          <div>
            <span class="mr-2" style="font-size:15px;">ITEM NO. </span>
            <span style="font-size:16px;font-weight:bold;">
              {{ data.sampleStyleNo }}
            </span>
          </div>

          <div>
            <span class="mr-5">{{ data.v_quotedMethod }}</span>
            <span class="quotedPrice">{{ data.quotedPrice }}</span>
            <span>{{ data.currencyUnit }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="context">
      <div class="context-item">
        <div class="context-item__label" v-if="data.expoSampleBrand">
          {{ data.expoSampleBrand }}
        </div>
        <div
          class="context-item__value"
          style="color:#101010"
          v-if="data.expoSampleName"
        >
          {{ data.expoSampleName }}
        </div>
      </div>
      <div class="context-item" v-if="data.expoSampleSpec">
        <div class="context-item__label">
          {{ $l('form_label_expoSampleSpec') || 'SIZE' }}
        </div>
        <div class="context-item__value">
          {{ data.expoSampleSpec }}
        </div>
      </div>
    </div>
    <!-- <div class="context">
      <div class="context-item">
        <div class="context-item__label">
          {{ $l('form_label_price') || 'PRICE' }}
        </div>
        <div class="context-item__value price">
          <div>{{ data.v_quotedMethod }}</div>
          <div>
            <span class="quotedPrice">{{ data.quotedPrice }}</span>
            <span>{{ data.currencyUnit }}</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="context show-more">
      <div class="context-item">
        <div class="context-item__value" v-if="data.isFabricPosition == 'N'">
          <p>{{ data.faceFabric }}</p>
        </div>
        <div class="context-item__value" v-if="data.isFabricPosition == 'Y'">
          <p v-if="data.faceFabric">
            {{
              `${this.$l('form_label_faceFabricEn') || 'Face'}: ${
                data.faceFabric
              }`
            }}
          </p>
          <p v-if="data.innerFabric">
            {{
              `${this.$l('form_label_innerFabricEn') || 'Face'}: ${
                data.innerFabric
              }`
            }}
          </p>
          <p v-if="data.backFabric">
            {{
              `${this.$l('form_label_backFabricEn') || 'Face'}: ${
                data.backFabric
              }`
            }}
          </p>
        </div>
      </div>
      <div class="show_more-btn">
        <span @click="showMore = !showMore">
          {{ $l('btn_more') || 'more' }}
        </span>
        <i
          class="el-icon-arrow-down"
          v-if="showMore"
          @click="showMore = !showMore"
        />
        <i
          class="el-icon-arrow-right"
          v-if="!showMore"
          @click="showMore = !showMore"
        />
      </div>
    </div>
    <el-collapse-transition>
      <div v-show="showMore">
        <div class="context" v-if="data.expoSampleDesc">
          <div class="context-item">
            <div class="context-item__label">
              {{ $l('form_label_expoSampleDesc') || 'DESCRIPTION' }}
            </div>
            <div class="context-item__value">
              {{ data.expoSampleDesc }}
            </div>
          </div>
        </div>
        <div class="context" v-if="data.remark">
          <div class="context-item">
            <div class="context-item__label">
              {{ $l('form_label_remark') || 'REMARK' }}
            </div>
            <div class="context-item__value">
              {{ data.remark }}
            </div>
          </div>
        </div>
        <div
          class="context"
          v-if="listSamplePropertiesImgUrl && listSamplePropertiesImgUrl.length"
        >
          <div class="context-item">
            <div class="context-item__label">
              {{ $l('form_label_features') || 'FEATURES' }}
            </div>
            <div class="context-item__value features">
              <el-image
                v-for="src in listSamplePropertiesImgUrl"
                :key="src"
                :src="src"
              />
            </div>
          </div>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  props: { data: { type: Object, default: () => {} } },
  data() {
    return { showMore: false }
  },
  computed: {
    listSamplePropertiesImgUrl() {
      const { listSamplePropertiesImgUrl } = this.data
      return listSamplePropertiesImgUrl || []
    },
  },
}
</script>

<style lang="scss" scoped>
.context-wrapper {
  .context {
    border-bottom: 1px solid #efefef;
    padding: 2px 0;
    color: #4f4f4f;
    .context-item {
      margin-bottom: 15px;
      font-size: 14px;
    }
    .context-item:last-child {
      margin-bottom: 0;
    }
    .context-item .context-item__label {
      color: #101010;
      margin-bottom: 8px;
      font-weight: 600;
    }
    .context-item .context-item__label:empty {
      display: none;
    }
    .context-item .context-item__value {
      line-height: 20px;
      white-space: pre-line;
      word-wrap: break-word;
      word-break: break-all;
    }
    .context-item .context-item__value:empty {
      display: none;
    }
    .context-item .context-item__value p {
      margin-bottom: 6px;
    }
    .context-item .context-item__value p:last-child {
      margin-bottom: 0;
    }
    .context-item .context-item__value.price {
      display: flex;
      justify-content: space-between;
      .quotedPrice {
        color: rgba(40, 167, 69, 1);
        font-size: 20px;
        margin-right: 6px;
      }
    }
    .context-item .context-item__value.features {
      display: flex;
      flex-wrap: wrap;
      .el-image {
        width: calc(calc(100% / 5) - calc(10px * 4 / 5));
        margin-right: 10px;
        margin-top: 10px;
      }
      .el-image:nth-child(-n + 5) {
        margin-top: 0;
      }
      .el-image:nth-child(5n + 5) {
        margin-right: 0;
      }
    }
  }
  .context:last-child {
    border-bottom: none;
  }
  .context.show-more {
    padding-bottom: 0;
    .context-item {
      margin-bottom: 0;
    }
    .show_more-btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: pointer;
      span {
        color: rgba(142, 142, 142, 1);
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
}
</style>
